<template>
  <!-- <el-dropdown
    trigger="hover"
    @command="create">
    <el-button type="primary">
      新建检验报告<i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-if="tradeTypes.indexOf(1) > -1"
        :command="1">进出口</el-dropdown-item>
      <el-dropdown-item
        v-if="tradeTypes.indexOf(3) > -1"
        :command="3">国内</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown> -->
  <el-button
    type="primary"
    @click="create(3)">
    新建质量报告
  </el-button>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CreateInspectBtn',
  data() {
    return {
      tradeTypes: []
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  mounted() {
    // this.getvendortradetypes()
  },
  methods: {
    create(type) {
      this.$router.push(`/inspect-create?vendorId=${this.userInfo.orgId}&tradeType=${type}`)
    },
    getvendortradetypes() {
      this.$store.dispatch('vendor/getvendortradetypes', {
        payload: {
          vendorId: this.userInfo.orgId
        },
        success: (res) => {
          this.tradeTypes = res.data.tradeTypes
        },
        fail: () => {
          this.tradeTypes = []
        }
      })
    }
  }
}
</script>
